// Validatore di lunghezza per la textarea "Testo personalizzato" di Customily (v2)
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {

    const MAX_RIGHE = 2;

    // Mappa dei vincoli: caratteri massimi PER RIGA, per singolo font
    const LIMITE_CARATTERI = {
        "Arial": 18,
        "Georgia": 18,
        "Impact": 18,
        "Trebuchet MS": 18,
        "Times New Roman": 18,
        "Verdana Bold": 18,
        "Copperplate Gothic Bold": 18,
        "Harlow Solid Italic": 18,
        "Lucida Sans": 18,
        "Lucida Calligraphy": 18,
        "Lucida Handwriting": 18,
        "Magneto": 18,
        "OCR A Extended": 18,
        "Old English Text": 18,
        "Vivaldi": 18
    };

    function getSelectedFont() {
        const checked = document.querySelector('input[name="properties[Font]"]:checked');
        return checked ? checked.value.trim() : null;
    }

    function getMaxCharsPerLine() {
        const font = getSelectedFont() || "Arial";
        return LIMITE_CARATTERI[font] || 18;
    }

    // Blocca/sblocca aggiungi al carrello
    function toggleCartButton(disable) {
        const btns = document.querySelectorAll('#customily-cart-btn, .add-to-cart-button');
        btns.forEach((btn) => {
            btn.disabled = disable;
            btn.style.opacity = disable ? '0.6' : '1';
            btn.style.pointerEvents = disable ? 'none' : 'auto';
        });
    }

    function syncCustomily(element) {
        const event = new Event('input', { bubbles: true });
        element.dispatchEvent(event);

        // Alcune versioni di Customily ascoltano il 'change' o il 'blur'
        const changeEvent = new Event('change', { bubbles: true });
        element.dispatchEvent(changeEvent);
    }

    // Tronca il testo rispettando: max righe, e su ciascuna riga il limite per-riga
    function normalizzaTesto(valore, maxPerRiga) {
        const righe = valore.split('\n').slice(0, MAX_RIGHE);
        return righe
            .map(riga => riga.substring(0, maxPerRiga))
            .join('\n');
    }

    function analizzaTesto(valore, maxPerRiga) {
        const righeGrezze = valore.split('\n');
        const righeInEccesso = righeGrezze.length > MAX_RIGHE;
        const righeConsiderate = righeGrezze.slice(0, MAX_RIGHE);
        const rigaTroppoLunga = righeConsiderate.some(r => r.length > maxPerRiga);

        return {
            superaLimite: righeInEccesso || rigaTroppoLunga,
            righeInEccesso,
            rigaTroppoLunga,
            numRighe: righeGrezze.length,
            righe: righeConsiderate
        };
    }

    const observer = new MutationObserver(() => {
        const textInput = document.querySelector('textarea[name="properties[Testo personalizzato]"]');
        if (textInput && !document.querySelector('#char-counter')) {
            const parent = textInput.closest('.cl-option-content');
            if (!parent) return;

            // Counter caratteri/righe
            const counter = document.createElement('div');
            counter.id = 'char-counter';
            counter.style.marginTop = '6px';
            counter.style.fontSize = '14px';
            counter.style.fontFamily = 'inherit';
            counter.style.color = '#444';
            counter.style.textAlign = 'right';

            const spacer = parent.querySelector('.bottom-spacer');
            if (spacer) parent.insertBefore(counter, spacer);
            else parent.appendChild(counter);

            // FIX: blocca la propagazione di Enter SOLO quando la textarea ha il focus.
            // Impedisce che il tema/Customily interpreti Invio come "vai avanti",
            // ma permette comunque di andare a capo (fino al limite di righe).
            textInput.addEventListener('keydown', (e) => {
                if (document.activeElement !== textInput) return;
                if (e.key !== 'Enter') return;

                e.preventDefault();
                e.stopPropagation();
                if (typeof e.stopImmediatePropagation === 'function') {
                    e.stopImmediatePropagation();
                }

                const maxPerRiga = getMaxCharsPerLine();
                const info = analizzaTesto(textInput.value, maxPerRiga);
                if (info.numRighe >= MAX_RIGHE) {
                    // Già al massimo delle righe consentite: Invio non fa nulla
                    return;
                }

                // Inserisce manualmente il newline nella posizione del cursore
                const start = textInput.selectionStart;
                const end = textInput.selectionEnd;
                const valore = textInput.value;
                textInput.value = valore.substring(0, start) + '\n' + valore.substring(end);
                textInput.selectionStart = textInput.selectionEnd = start + 1;

                syncCustomily(textInput);
                textInput.dispatchEvent(new Event('input'));
            });

            // Validazione su input (digitazione, incolla, ecc.)
            textInput.addEventListener('input', () => {
                const maxPerRiga = getMaxCharsPerLine();
                const info = analizzaTesto(textInput.value, maxPerRiga);

                if (info.superaLimite) {
                    if (!textInput.dataset.alerting) {
                        textInput.dataset.alerting = "true";
                        const font = getSelectedFont() || "Arial";
                        alert(`Il font ${font} supporta max ${maxPerRiga} caratteri per riga, su ${MAX_RIGHE} righe. Testo adattato.`);
                        setTimeout(() => delete textInput.dataset.alerting, 500);
                    }

                    // Notifica a Customily che il valore è cambiato dopo il taglio
                    syncCustomily(textInput);

                    // Slice al numero massimo di caratteri consentito sulla riga,
                    // mantenendo la posizione del cursore invece di farlo saltare in fondo
                    const cursorPos = textInput.selectionStart;
                    const valorePrima = textInput.value;
                    const valoreTagliato = normalizzaTesto(valorePrima, maxPerRiga);
                    const caratteriRimossi = valorePrima.length - valoreTagliato.length;
                    textInput.value = valoreTagliato;

                    const nuovaPos = Math.max(0, cursorPos - caratteriRimossi);
                    textInput.selectionStart = textInput.selectionEnd = Math.min(nuovaPos, valoreTagliato.length);

                    counter.style.color = '#dc2626';
                    counter.textContent = `Limite raggiunto — max ${maxPerRiga} caratteri per riga, ${MAX_RIGHE} righe`;
                    toggleCartButton(false);
                    return;
                }

                const righeAttuali = textInput.value.split('\n');
                const rigaPiuLunga = Math.max(0, ...righeAttuali.map(r => r.length));
                const remaining = maxPerRiga - rigaPiuLunga;
                counter.textContent = `${righeAttuali.length}/${MAX_RIGHE} righe — riga più lunga: ${rigaPiuLunga}/${maxPerRiga}`;

                if (remaining <= 3) {
                    counter.style.color = '#d97706';
                } else {
                    counter.style.color = '#444';
                }

                toggleCartButton(false);
            });

            // Ricalcola se il font cambia
            const fontInputs = document.querySelectorAll('input[name="properties[Font]"]');
            fontInputs.forEach(f => f.addEventListener('change', () => {
                textInput.dispatchEvent(new Event('input'));
            }));

            // Trigger iniziale
            textInput.dispatchEvent(new Event('input'));

            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});